import { TagContextProvider, TagRefreshButton } from '@abtasty/tag-refresh-button';
import { memo, useMemo } from 'react';
import { de, enUS, es, fr } from 'date-fns/locale';

import { useSegmentTrack } from '@application/hooks/useSegment/useSegment';
import { useAccountId, useRole, useSharding } from '@src/application/modules/tag/hooks/hooks';

import { useTagData } from '../../shared/tag/context/useTagData';
import { useUserContext } from '../../shared/tag/context/UserContext/useUserContext';
import { PackType, Timezone, UserRoles } from '@abtasty/api-client';
import { hasMinimumRole } from '../../shared/helpers';

export const localeByLanguage = {
  en_US: enUS,
  de,
  es,
  fr,
};

export const TagRefresh = memo(() => {
  const accountId = useAccountId();
  const role = useRole();
  const isUsingSharding = useSharding();
  const { profile } = useUserContext();
  const sendTracking = useSegmentTrack();
  const tagData = useTagData();

  const { pack, frameworkVersion } = tagData?.accountData?.accountSettings;
  const language = profile?.value?.lang || 'en_US';
  const locale = localeByLanguage[language];
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone as Timezone;
  const tagFrameworkPage = `${process.env.APP_URL}/settings/performance-center/guidelines#compilationErrors`;

  const onEvent = (eventName: string) => {
    switch (eventName) {
      case 'compile-tag-clicked':
        sendTracking('CS-ck- Tag refresh qaa');
        break;

      default:
        break;
    }
  };

  const disabledReason = useMemo(() => {
    if (pack === PackType.Inactive) return 'inactive';
    if (!role || !hasMinimumRole(role, UserRoles.user)) return 'rights';
    return undefined;
  }, [pack, role]);

  return (
    <TagContextProvider
      settingsUrl={tagFrameworkPage}
      accountId={accountId!}
      tagVersion={frameworkVersion}
      language={language}
      locale={locale}
      timezone={timezone}
      apiHostname={process.env.API_HOST_DEFAULT}
      onEvent={onEvent}
      disabledReason={disabledReason}
      useSharding={isUsingSharding}
      openLinkInNewTab
    >
      <TagRefreshButton />
    </TagContextProvider>
  );
});
